module.exports = __webpack_public_path__ + "files/246450f1f9b984bd713e07f112fa37f3.png";